export enum ToastType {
  Info = "info",
  Warn = "warn",
  Success = "success",
}
